<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import Conexoes from '../Classes/Conexoes.js';
  import Constantes from '../Classes/Constantes.js';
  import { baseUrl } from '../Classes/Stores.js';

  // Estados dinâmicos de valores vindos do banco de dados
  let valorInicial = 0;
  let valorRenovacao = 29.90;
  let diasGratis = 10;

  // Estados simples para o formulário de cadastro/captura da oferta
  let nomeProfissional = '';
  let email = '';
  let whatsapp = '';
  let senha = ''; 
  let slugDesejado = '';

  // Estados de controle da tela
  let isLoading = false;
  let mensagemErro = '';

  // Estados para a checagem do Slug
  let verificandoSlug = false;
  let slugDisponivel = null; 
  let timeoutId;

  onMount(() => {
    carregarValoresSistema();
  });

  // Busca os valores vigentes no padrão arquitetural Conexoes
  async function carregarValoresSistema() {
    const conexao = new Conexoes();
    const res = await conexao.conecta(Constantes.api_obter_valores);
    if (res && res.sucesso) {
      valorInicial = Number(res.valor_inicial || 0);
      valorRenovacao = Number(res.valor_renovacao || 29.90);
      diasGratis = Number(res.dias_gratis || 10);
    }
  }

  function irParaLogin() {
    navigate('/login');
  }

  function checarSlug() {
    slugDesejado = slugDesejado.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9-]/g, '').replace(/\s+/g, '-');
    if (slugDesejado.length < 3) {
      slugDisponivel = null;
      return;
    }

    clearTimeout(timeoutId);
    slugDisponivel = null;
    verificandoSlug = true;

    timeoutId = setTimeout(async () => {
      const conexao = new Conexoes();
      const res = await conexao.conecta(Constantes.api_verificar_slug, { body: { slug: slugDesejado } });

      verificandoSlug = false;
      if (res && typeof res.disponivel !== 'undefined') {
        slugDisponivel = res.disponivel;
      }
    }, 600);
  }

  async function iniciarContratacao(event) {
    event.preventDefault();
    if (!nomeProfissional || !email || !senha || !whatsapp || !slugDesejado) {
      alert("Por favor, preencha todos os campos para garantir a sua vaga.");
      return;
    }

    if (senha.length < 6) {
      alert("A sua senha deve ter pelo menos 6 caracteres.");
      return;
    }

    if (slugDisponivel === false) {
      mensagemErro = 'O link desejado já está em uso. Por favor, escolha outro.';
      document.getElementById('lp_slug').focus();
      return;
    }

    mensagemErro = '';
    isLoading = true;
    try {
      const conexao = new Conexoes();
      // Chama a nova API apenas para registrar o usuário
      const res = await conexao.conecta(Constantes.api_registrar_usuario, {
        nome: nomeProfissional,
        email,
        senha,
        whatsapp,
        slug: slugDesejado
      });
      if (!res || res.error) {
        mensagemErro = res?.message || res?.error || 'Falha ao criar sua conta. Tente novamente.';
        alert(mensagemErro);
        isLoading = false;
        return;
      }

      
      
      // Função segura de navegação para evitar duplicação
      let navegacaoRealizada = false;
      const irParaPainel = () => {
        if (!navegacaoRealizada) {
          navegacaoRealizada = true;
          navigate('/login');
        }
      };
if (typeof fbq === 'function') {
  fbq('track', 'CompleteRegistration', {
    value: valorInicial,
    currency: 'BRL',
    content_name: slugDesejado
  });
}
      // Dispara conversão de Compra para o Google Ads
      if (typeof gtag === 'function') {
        gtag('event', 'conversion', {
          'send_to': 'AW-964653439/F9t4COKkqbgcEP_i_csD',
          'value': valorInicial,
          'currency': 'BRL',
          'transaction_id': res.tenant?.id || '',
          'event_callback': irParaPainel // Navega apenas quando a tag confirmar o disparo
        });
        
        // Fallback de segurança: Se o gtag for bloqueado (ex: Adblock), força a navegação após 500ms
        setTimeout(irParaPainel, 500);
      } else {
        // Se o gtag nem existir na página, vai direto para o painel
        irParaPainel();
      }

    } catch (error) {
      console.error('Erro ao registrar:', error);
      mensagemErro = 'Erro de conexão. Verifique sua internet.';
      alert(mensagemErro);
    } finally {
      isLoading = false;
    }
  }
</script>

<svelte:head>
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800&family=Urbanist:wght@400;600;700;800&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css">
</svelte:head>

<div class="lp-body">
  <div class="container">
    <header class="nav">
      <div class="logo"> 
        <img class="logo-img" src="img/logo2.webp" alt="Demonstração do Hora na Mão" />
      </div>
      <button class="btn-login" on:click={irParaLogin}>
        <i class="fas fa-sign-in-alt me-2"></i> Entrar no Painel
      </button>
    </header>

    <section class="hero">
      <div class="hero-text">
        <h1>Sua agenda no <span>automático</span>, sua vida na mão.</h1>
        <p>Pare de perder horas combinando horários no WhatsApp. Deixe seus clientes agendarem sozinhos em 3 cliques, com sincronização em tempo real com o seu Google Agenda.</p>
        <a href="#contratar" class="btn-cta">Começar com {diasGratis} dias grátis</a>
      </div>
      <div class="hero-img">
        <img src="img/banner-hero.webp" alt="Demonstração do Hora na Mão" style="width: 100%; border-radius: 24px; box-shadow: 0 15px 35px rgba(74, 108, 86, 0.15);" />
      </div>
    </section>
  </div>

  <section class="pain">
    <div class="container">
      <h2>Você ainda vive preso a essa rotina?</h2>
      <p class="section-subtext">Gerenciar horários manualmente custa mais caro do que você imagina.</p>
      
      <div class="pain-grid">
        <div class="pain-card">
          <i class="fab fa-whatsapp"></i>
          <h3>Escravo do WhatsApp</h3>
          <p>Respondendo mensagens de clientes às 22h de um domingo ou interrompendo os seus momentos de lazer e refeições.</p>
        </div>
        <div class="pain-card">
          <i class="fas fa-calendar-times"></i>
          <h3>Furos Graves na Agenda</h3>
          <p>Clientes que esquecem do compromisso em cima da hora porque você simplesmente não teve tempo de lembrá-los na véspera.</p>
        </div>
        <div class="pain-card">
          <i class="fas fa-brain"></i>
          <h3>Sobrecarga Mental</h3>
          <p>Ter que gerenciar encaixes, desmarques, remarcações e listas de espera em blocos de papel ou conversas soltas.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="comparison">
    <div class="container">
      <h2>O cálculo é simples. A economia é real.</h2>
      <p class="section-subtext mb-5">Compare o peso de uma estrutura analógica tradicional com a inteligência digital.</p>
      
      <div class="comp-table">
        <div class="comp-col secretary">
          <h3>Uma Secretária Física</h3>
          <div class="comp-price red">R$ 1.500+<span>/mês</span></div>
          <p class="text-muted">Custo médio considerando salário e encargos</p>
          <ul class="comp-list">
            <li><i class="fas fa-times"></i> Erros humanos e esquecimentos nas marcações</li>
            <li><i class="fas fa-times"></i> Não trabalha 24h por dia, nem nos feriados</li>
            <li><i class="fas fa-times"></i> Gargalo de atendimento (uma chamada por vez)</li>
          </ul>
        </div>
        
        <div class="comp-col app">
          <div class="recommended-badge">Melhor Custo-Benefício</div>
          <h3>Plataforma Hora na Mão</h3>
          <div class="comp-price gold">R$ {valorRenovacao.toLocaleString('pt-BR', {minimumFractionDigits: 2})}<span>/mês</span></div>
          <p style="color: #e2e8f0; font-size: 0.9rem;">Sua agenda digital autônoma</p>
          <ul class="comp-list">
            <li><i class="fas fa-check"></i> 100% de precisão e segurança nos dados</li>
            <li><i class="fas fa-check"></i> Trabalha domingo a domingo, 24 horas por dia</li>
            <li><i class="fas fa-check"></i> Sincronização automática com seu celular</li>
            <li><i class="fas fa-check"></i> Envio automático de lembretes na véspera</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="features">
    <div class="container">
      <h2>Tudo o que você precisa para assumir o controle</h2>
      <div class="feat-grid">
        <div class="feat-tile">
          <div class="feat-icon"><i class="fab fa-google"></i></div>
          <div>
            <h3>Google Sync Blindado</h3>
            <p>Os agendamentos feitos pelos clientes entram no calendário do seu celular na mesma hora. Sem conflito de horários.</p>
          </div>
        </div>
        
        <div class="feat-tile">
          <div class="feat-icon"><i class="fas fa-bell"></i></div>
          <div>
            <h3>Motor de Confirmação</h3>
            <p>Reduza faltas em até 80%. O sistema envia e-mails e alertas para o cliente confirmar ou liberar a vaga na véspera.</p>
          </div>
        </div>
        
        <div class="feat-tile">
          <div class="feat-icon"><i class="fas fa-link"></i></div>
          <div>
            <h3>Link Profissional na Bio</h3>
            <p>Transmita autoridade máxima. Um endereço limpo e elegante para fixar no seu Instagram e enviar no topo do WhatsApp.</p>
          </div>
        </div>
        
        <div class="feat-tile">
          <div class="feat-icon"><i class="fas fa-user-edit"></i></div>
          <div>
            <h3>Formulário Sob Medida</h3>
            <p>Você escolhe quais dados quer coletar: decida se campos como CPF, Nascimento ou Endereço serão obrigatórios, opcionais ou ocultos.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="professions-section fade-in">
    <div class="section-header text-center">
      <h2 class="section-title">Para quem é o <span class="highlight">Hora na Mão</span>?</h2>
      <p class="section-subtitle">Se você atende com hora marcada, nosso sistema foi desenhado para você escalar seus atendimentos.</p>
    </div>

    <div class="professions-grid">
      <div class="profession-card">
        <div class="icon-wrapper">
          <i class="fas fa-heartbeat"></i>
        </div>
        <h3>Saúde e Bem-estar</h3>
        <p>Nutricionistas, Psicólogos, Fisioterapeutas e Médicos.</p>
      </div>

      <div class="profession-card">
        <div class="icon-wrapper">
          <i class="fas fa-spa"></i>
        </div>
        <h3>Beleza e Estética</h3>
        <p>Cabeleireiros, Barbeiros, Manicures, Lash Designers e Esteticistas.</p>
      </div>

      <div class="profession-card">
        <div class="icon-wrapper">
          <i class="fas fa-dumbbell"></i>
        </div>
        <h3>Treinos e Aulas</h3>
        <p>Personal Trainers, Professores Particulares e Instrutores.</p>
      </div>

      <div class="profession-card">
        <div class="icon-wrapper">
          <i class="fas fa-briefcase"></i>
        </div>
        <h3>Consultoria e Serviços</h3>
        <p>Advogados, Contadores, Coaches e Consultores Independentes.</p>
      </div>
    </div>
  </section>

  <section class="checkout" id="contratar">
    <div class="container">
      <div class="checkout-box">
        <div class="offer-details">
          <h2>Oferta Especial de Lançamento</h2>
          <p>Experimente a liberdade de ter o seu negócio rodando no automático sem qualquer risco.</p>
          
          <div class="price-tag">
            <span class="old">Preço normal: R$ {valorRenovacao.toLocaleString('pt-BR', {minimumFractionDigits: 2})}</span>
            <span class="new">{diasGratis} dias grátis <span>para começar</span></span>
          </div>
          
          <p class="text-muted">
            Seu acesso começa com {diasGratis} dias grátis e depois você compra créditos quando quiser. O valor de renovação continua em R$ {valorRenovacao.toLocaleString('pt-BR', {minimumFractionDigits: 2})}/mês,  <strong>sem fidelidade</strong> e sem renovação automática. 
            <strong>Oferta por tempo limitado:</strong> ative agora antes que o período de teste termine.
          </p>
          
          <div class="trust-indicators">
            <div><i class="fas fa-shield-alt"></i> Pagamento Seguro via PIX</div>
            <div><i class="fas fa-bolt"></i> Ativação Imediata da Agenda</div>
          </div>
        </div>

        <div class="form-card">
          <h3>Crie sua Conta</h3>
          <p class="mb-4 text-muted">Preencha os dados básicos para reservar o seu link exclusivo.</p>
          
          <form on:submit={iniciarContratacao}>
            <div class="input-group">
              <label for="lp_nome">Seu Nome Profissional *</label>
              <input type="text" id="lp_nome" bind:value={nomeProfissional} placeholder="Ex: Dra. Aline Susan" required />
            </div>
            
            <div class="input-group">
              <label for="lp_email">Seu Melhor E-mail *</label>
              <input type="email" id="lp_email" bind:value={email} placeholder="nome@empresa.com" required />
            </div>

            <div class="input-group">
              <label for="lp_senha">Crie uma Senha para o Painel *</label>
              <input type="password" id="lp_senha" bind:value={senha} placeholder="Mínimo de 6 caracteres" required minlength="6" />
            </div>

            <div class="input-group">
              <label for="lp_tel">WhatsApp com DDD *</label>
              <input type="tel" id="lp_tel" bind:value={whatsapp} placeholder="(00) 00000-0000" required />
            </div>
            
            <div class="input-group">
              <label for="lp_slug">Link Desejado para sua Agenda *</label>
              <div class="slug-input-wrapper {slugDisponivel === false ? 'slug-erro' : slugDisponivel === true ? 'slug-sucesso' : ''}">
                <span class="slug-prefix">horanamao.com.br/agendar/</span>
                <input type="text" id="lp_slug" bind:value={slugDesejado} on:input={checarSlug} placeholder="seu-nome" required />
                <div class="slug-feedback">
                  {#if verificandoSlug}
                    <i class="fas fa-spinner fa-spin text-muted"></i>
                  {:else if slugDisponivel === true}
                    <i class="fas fa-check-circle" style="color: #38a169;"></i>
                  {:else if slugDisponivel === false}
                    <i class="fas fa-times-circle" style="color: #e53e3e;"></i>
                  {/if}
                </div>
              </div>

              {#if slugDisponivel === false}
                 <small style="color: #e53e3e; margin-top: 5px; font-weight: 600;">Este link já está em uso. Escolha outro.</small>
              {:else if slugDisponivel === true}
                 <small style="color: #38a169; margin-top: 5px; font-weight: 600;">Link disponível!</small>
              {/if}
            </div>
           
            <button type="submit" class="btn-primary w-100 mt-3" disabled={isLoading}>
              {#if isLoading}
                <i class="fas fa-spinner fa-spin me-2"></i> Gerando PIX Seguro...
              {:else}
                <i class="fas fa-rocket me-2"></i> Ativar Minha Agenda Agora
              {/if}
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>
<footer class="site-footer">
    <div class="container footer-content">
      <div class="footer-info">
        <p>&copy; {new Date().getFullYear()} Hora na Mão - Sistema de Agendamentos Inteligentes</p>
        <p class="text-muted" style="font-size: 0.8rem;">Plataforma desenvolvida e administrada por Alline Susan Paz de Menezes (andlline2@gmail.com)</p>
      </div>
      <div class="footer-links">
        <a href="https://horanamao.com.br/privacidade.php" target="_blank">Termos de Uso</a>
        <a href="https://horanamao.com.br/privacidade.php" target="_blank">Política de Privacidade</a>
      </div>
    </div>
  </footer>
<style>
  .lp-body {
    --primary: #4a6c56;
    --primary-dark: #3a5443;
    --accent: #cfaa6c;
    --accent-hover: #b8955a;
    --text-main: #1a2a20;
    --text-muted: #5a7063;
    --bg-light: #f4f7f5;
    --white: #ffffff;
    --danger: #c53030;
    --border: #e0e6e2;
    --secondary-light: #eef5f0;
    background-color: var(--bg-light);
    color: var(--text-main);
    font-family: 'Urbanist', sans-serif;
    line-height: 1.5;
  }
  .container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
  h1, h2, h3 { font-family: 'Montserrat', sans-serif; color: var(--text-main); }
  .text-muted { color: var(--text-muted); }
  .mb-4 { margin-bottom: 20px; }
  .mb-5 { margin-bottom: 40px; }
  .mt-3 { margin-top: 15px; }
  .w-100 { width: 100%; }
  .me-2 { margin-right: 8px; }
  header.nav { padding: 25px 0; display: flex; justify-content: space-between; align-items: center; }
  .logo { display: flex; align-items: center; gap: 8px; }
  .logo-img { width: 500px; max-width: 100%; } 
  .btn-login { background: transparent; border: 2px solid var(--primary); color: var(--primary); padding: 10px 22px; border-radius: 8px; font-weight: 700; cursor: pointer; transition: 0.2s; }
  .btn-login:hover { background: var(--secondary-light); }
  section.hero { padding: 60px 0 100px 0; display: grid; grid-template-columns: 1fr 1fr; gap: 60px; align-items: center; }
  .hero-text h1 { font-size: 3.2rem; font-weight: 800; line-height: 1.1; margin-bottom: 25px; color: var(--primary); }
  .hero-text h1 span { color: var(--accent); }
  .hero-text p { font-size: 1.25rem; color: var(--text-muted); margin-bottom: 40px; font-weight: 500; }
  .btn-cta { background: var(--primary); color: white; padding: 18px 38px; border-radius: 12px; font-size: 1.15rem; font-weight: 700; text-decoration: none; display: inline-block; transition: 0.3s; box-shadow: 0 10px 25px rgba(74, 108, 86, 0.2); border: none; }
  .btn-cta:hover { background: var(--primary-dark); transform: translateY(-3px); box-shadow: 0 12px 30px rgba(74, 108, 86, 0.3); }
  
  section.pain { padding: 90px 0; background: var(--white); text-align: center; border-top: 1px solid var(--border); }
  section.pain h2, section.comparison h2, section.features h2 { font-size: 2.2rem; font-weight: 800; color: var(--primary); margin-bottom: 10px; }
  .section-subtext { font-size: 1.1rem; color: var(--text-muted); font-weight: 500; }
  .pain-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px; margin-top: 50px; }
  .pain-card { padding: 40px 30px; border-radius: 20px; background: #fff5f5; border: 1px solid #fed7d7; text-align: left; transition: 0.2s; }
  .pain-card:hover { transform: translateY(-4px); }
  .pain-card i { font-size: 2.5rem; color: var(--danger); margin-bottom: 20px; }
  .pain-card h3 { font-size: 1.25rem; font-weight: 700; margin-bottom: 12px; color: #9b2c2c; }
  .pain-card p { font-size: 0.95rem; color: #c53030; line-height: 1.5; font-weight: 600; }
  
  section.comparison { padding: 90px 0; background: #edf2ee; border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); text-align: center; }
  .comp-table { background: white; border-radius: 24px; overflow: hidden; box-shadow: 0 20px 50px rgba(0,0,0,0.04); display: grid; grid-template-columns: 1fr 1fr; margin-top: 45px; text-align: left; }
  .comp-col { padding: 60px; }
  .comp-col.secretary { border-right: 1px solid var(--border); background: #fafcfa; }
  .comp-col.app { background: var(--primary); color: white; position: relative; }
  .comp-col h3 { font-size: 1.5rem; margin-bottom: 20px; font-weight: 800; }
  .comp-col.app h3 { color: white; }
  .comp-price { font-size: 3.5rem; font-weight: 800; line-height: 1; margin-bottom: 5px; letter-spacing: -1px; }
  .comp-price span { font-size: 1.2rem; font-weight: 500; }
  .comp-price.red { color: var(--danger); }
  .comp-price.gold { color: var(--accent); }
  .comp-list { list-style: none; margin-top: 35px; }
  .comp-list li { margin-bottom: 18px; display: flex; gap: 12px; align-items: flex-start; font-size: 1.05rem; font-weight: 600; }
  .comp-col.secretary .comp-list li i { color: var(--danger); margin-top: 4px; }
  .comp-col.app .comp-list li i { color: #deff9a; margin-top: 4px; }
  .recommended-badge { position: absolute; top: 25px; right: 25px; background: rgba(255,255,255,0.15); color: #deff9a; padding: 6px 14px; border-radius: 20px; font-weight: 800; font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.5px; }
  
  section.features { padding: 90px 0; text-align: center; }
  .feat-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 25px; margin-top: 50px; text-align: left; }
  .feat-tile { background: white; padding: 35px; border-radius: 20px; border: 1px solid var(--border); display: flex; gap: 20px; transition: 0.2s; }
  .feat-tile:hover { border-color: var(--primary); box-shadow: 0 10px 30px rgba(0,0,0,0.02); }
  .feat-icon { width: 55px; height: 55px; background: var(--secondary-light); border-radius: 12px; display: grid; place-items: center; font-size: 1.4rem; color: var(--primary); flex-shrink: 0; }
  .feat-tile h3 { font-size: 1.2rem; margin-bottom: 8px; font-weight: 700; color: var(--primary); }
  .feat-tile p { font-size: 0.95rem; color: var(--text-muted); }

  /* =========================================
     SESSÃO: PARA QUEM É (PROFISSÕES)
  ========================================= */
  .professions-section {
    padding: 60px 20px;
    background-color: var(--bg-light);
    max-width: 1200px;
    margin: 0 auto;
  }
  .text-center { text-align: center; }
  .section-title { font-family: 'Montserrat', sans-serif; font-size: 2.2rem; font-weight: 800; color: var(--primary); margin-bottom: 10px; }
  .section-title .highlight { color: var(--accent); }
  .section-subtitle { font-size: 1.1rem; color: var(--text-muted); margin-bottom: 40px; max-width: 600px; margin-left: auto; margin-right: auto; }
  
  .professions-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 30px;
  }
  .profession-card {
    background: #ffffff;
    padding: 30px 20px;
    border-radius: 16px;
    text-align: center;
    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
    border: 1px solid var(--border);
    transition: all 0.3s ease;
  }
  .profession-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 40px rgba(74, 108, 86, 0.15);
    border-color: var(--accent);
  }
  .icon-wrapper {
    width: 70px; height: 70px;
    background: var(--secondary-light);
    color: var(--primary);
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 2rem; margin: 0 auto 20px auto; transition: all 0.3s ease;
  }
  .profession-card:hover .icon-wrapper {
    background: var(--primary); color: #ffffff;
  }
  .profession-card h3 { font-size: 1.2rem; font-weight: 700; color: var(--text-main); margin-bottom: 10px; }
  .profession-card p { font-size: 0.95rem; color: var(--text-muted); line-height: 1.5; margin: 0; }

  section.checkout { padding: 100px 0; background: var(--white); border-top: 1px solid var(--border); }
  .checkout-box { max-width: 960px; margin: 0 auto; display: grid; grid-template-columns: 1.1fr 0.9fr; gap: 60px; align-items: center; }
  .offer-details h2 { font-size: 2.3rem; font-weight: 800; color: var(--primary); line-height: 1.1; margin-bottom: 15px; }
  .price-tag { margin: 30px 0; display: flex; flex-direction: column; }
  .price-tag .old { text-decoration: line-through; color: var(--text-muted); font-size: 1.3rem; font-weight: 600; }
  .price-tag .new { font-size: 4rem; font-weight: 800; color: var(--primary); line-height: 1; margin-top: 5px; letter-spacing: -1px; }
  .price-tag .new span { font-size: 1.3rem; color: var(--text-muted); font-weight: 500; letter-spacing: 0; }
  .trust-indicators { margin-top: 35px; display: flex; flex-direction: column; gap: 12px; }
  .trust-indicators div { display: flex; align-items: center; gap: 10px; font-weight: 700; color: var(--primary); font-size: 0.95rem; }
  
  .form-card { background: var(--bg-light); padding: 40px; border-radius: 24px; border: 2px solid var(--primary); box-shadow: 0 15px 35px rgba(74, 108, 86, 0.08); text-align: left; }
  .form-card h3 { font-size: 1.4rem; font-weight: 800; color: var(--primary); margin-bottom: 15px; }
  .input-group { margin-bottom: 18px; display: flex; flex-direction: column; }
  .input-group label { display: block; font-weight: 700; margin-bottom: 6px; font-size: 0.85rem; color: var(--text-main); }
  .input-group input { width: 100%; padding: 13px 15px; border: 1px solid var(--border); border-radius: 8px; background: white; font-family: inherit; font-size: 0.95rem; }
  .input-group input:focus { outline: none; border-color: var(--primary); box-shadow: 0 0 0 3px rgba(74, 108, 86, 0.1); }
  
  .slug-input-wrapper { display: flex; align-items: center; border: 1px solid var(--border); border-radius: 8px; background: #e8eee9; overflow: hidden; position: relative; transition: all 0.3s; width: 100%; }
  .slug-prefix { padding: 0 12px; font-size: 0.9rem; color: var(--text-muted); font-weight: 700; white-space: nowrap; }
  .slug-input-wrapper input { border: none; border-radius: 0; border-left: 1px solid var(--border); width: 100%; padding-right: 40px; }
  .slug-feedback { position: absolute; right: 15px; top: 50%; transform: translateY(-50%); font-size: 1.1rem; }
  .slug-input-wrapper.slug-erro { border-color: #e53e3e; box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.1); }
  .slug-input-wrapper.slug-sucesso { border-color: #38a169; box-shadow: 0 0 0 3px rgba(56, 161, 105, 0.1); }
  
  .btn-primary { background: var(--primary); color: white; border: none; padding: 16px; border-radius: 12px; font-weight: 700; font-size: 1.1rem; cursor: pointer; transition: 0.3s; }
  .btn-primary:hover:not(:disabled) { background: var(--primary-dark); transform: translateY(-2px); }
  .btn-primary:disabled { opacity: 0.7; cursor: not-allowed; }
  
  @media (max-width: 960px) {
    section.hero, .pain-grid, .comp-table, .feat-grid, .checkout-box { grid-template-columns: 1fr; gap: 40px; }
    .hero-text { text-align: center; }
    .hero-text h1 { font-size: 2.4rem; }
    .comp-col.secretary { border-right: none; border-bottom: 1px solid var(--border); }
    .checkout-box { max-width: 550px; }
    .logo-img { width: 100%; max-width: 250px; margin: 0 auto; }
  }

  /* =========================================
     SESSÃO: RODAPÉ / LEGAL (GOOGLE CLOUD)
  ========================================= */
  .site-footer {
    background-color: #1a2a20; /* Fundo bem escuro */
    color: #e2e8f0;
    padding: 40px 0 30px 0;
    text-align: center;
    border-top: 4px solid var(--primary);
    margin-top: 60px;
  }
  .footer-content {
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
  .footer-info p {
    margin: 5px 0;
    font-size: 0.95rem;
  }
  .footer-links {
    display: flex;
    gap: 30px;
    margin-top: 15px;
  }
  .footer-links a {
    color: var(--accent);
    text-decoration: none;
    font-weight: 700;
    font-size: 0.95rem;
    transition: color 0.2s;
  }
  .footer-links a:hover {
    color: #ffffff;
    text-decoration: underline;
  }
  @media (max-width: 640px) {
    .footer-links {
      flex-direction: column;
      gap: 15px;
    }
  }
</style>